import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { XCircle, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

const content = {
  pt: {
    title: "Pagamento Cancelado",
    subtitle: "O pagamento foi cancelado. Nenhuma cobrança foi realizada.",
    tryAgain: "Você pode tentar novamente quando quiser.",
    backToPlans: "Ver planos novamente",
    backHome: "Voltar ao início"
  },
  en: {
    title: "Payment Cancelled",
    subtitle: "The payment was cancelled. No charges were made.",
    tryAgain: "You can try again whenever you want.",
    backToPlans: "View plans again",
    backHome: "Back to home"
  }
};

export default function PaymentCancelled() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'pt';
  const t = content[currentLang] || content.pt;

  return (
    <div className="min-h-screen bg-[#1a1a2e] flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        <div className="bg-white/5 backdrop-blur rounded-2xl border border-white/10 p-8 text-center">
          {/* Cancel Icon */}
          <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-red-500" />
          </div>

          <h1 className="text-2xl font-bold text-white mb-2">{t.title}</h1>
          <p className="text-slate-400 mb-4">{t.subtitle}</p>
          <p className="text-slate-500 text-sm mb-8">{t.tryAgain}</p>

          {/* Actions */}
          <div className="space-y-3">
            <Link to="/#pricing">
              <Button className="w-full bg-[#f5a623] hover:bg-[#e09612] text-[#1a1a2e] font-semibold">
                {t.backToPlans}
              </Button>
            </Link>
            <Link to="/" className="block">
              <Button variant="outline" className="w-full border-white/20 text-white hover:bg-white/10">
                <ArrowLeft className="w-4 h-4 mr-2" />
                {t.backHome}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
